import React, { Component } from 'react';
import StepZilla from 'react-stepzilla';
import '../App.css';
import 'react-stepzilla/src/css/main.css';

import ProductName from './steps/ProductName.jsx';
import ConsumerName from './steps/ConsumerName.jsx';
import Summary from './steps/Summary.jsx';
import ProxyEnv from './steps/ProxyEnv.jsx';

class AddGroupToExistingConsumerHome extends Component {

	constructor(props) {
		super(props);
		this.state = {
			productName: '',
			adGroup:'',
			gitURL:'',
			consumerName:'',
			buildEnvironment: [],
			isSubmit: false
		};
	}

	getStore = () => {
		return this.state;
	};

	updateStore = (update) => {
		this.setState(update);
	};

	render() {
		const addGroupToExistingConsumerSteps = [
			{name: 'Build Environment', component: <ProxyEnv getStore={this.getStore} updateStore={this.updateStore}/>},
			{name: 'ProxyGroupName', component: <ProductName updateStore={this.updateStore} getStore={this.getStore}/>},
			{name: 'ConsumerName', component: <ConsumerName updateStore={this.updateStore} getStore={this.getStore}/>},
			{name: 'Summary', component: <Summary getStore={this.getStore}/>}
		];
		return (
			<div className="container">
				<h1>Add Proxy Group Access To Existing Consumer</h1>
				<hr/>
				<div className='step-progress'>
					<StepZilla
						preventEnterSubmission={true}
						nextButtonCls="btn btn-next btn-primary util-margin-top-50"
						backButtonCls="btn btn-prev btn-link util-margin-top-50"
						steps={addGroupToExistingConsumerSteps}
					/>
				</div>
			</div>
		);
	}
}

export default AddGroupToExistingConsumerHome;
